module.exports = __webpack_public_path__ + "img/floor1_4.d2da728b.jpg";